import React, {PureComponent} from "react"
import {Query as QueryComponent} from "@irati/utils/services/apollo"
import {Query} from "@irati/utils/apollo"
import partialUser from "@irati/identity/services/fragments/PartialUser"

import {Poll} from "@irati/types"
import {gql} from "@irati/utils/gql"
import RecognitionFeedReaction from "../../services/fragments/RecognitionFeedReaction"

const query = gql`
  query Poll($id: String) {
    poll(id: $id) {
      uuid
      createdAt
      endsAt
      title
      desc
      active
      archived
      allowAnonymousVoting
      winners {
        results {
          user {
            ...partialUser
          }
        }
      }
      teams {
        results {
          uuid
          public_name
        }
      }
      createdBy {
        ...partialUser
      }
      trophy {
        alt
        href
      }
      reward {
        desc
        alt
        href
      }
      votes {
        results {
          uuid
          message
          createdAt
          updatedAt
          createdBy {
            ...partialUser
          }
          user {
            ...partialUser
          }
          moderated
          archived
        }
      }
      comments {
        results {
          uuid
          createdAt
          updatedAt
          createdBy {
            ...partialUser
          }
          message
          moderated
          archived
          reactions {
            results {
              ...reactionFields
            }
          }
        }
      }
      reactions {
        results {
          ...reactionFields
        }
      }
      companyValues {
        results {
          archived
          name
          tag
          uuid
        }
      }
    }
  }
  ${RecognitionFeedReaction}
  ${partialUser}
`

interface OpenPollVariables {
  id: string
}

export interface OpenPollData {
  data: {
    poll: Poll
  }
}

interface Props {
  variables: OpenPollVariables
}

// @todo used by web
// Once web is refactored to use QueryComponent delete this
export const openPollQuery = {
  query
}

class TypedQuery extends Query<OpenPollData, OpenPollVariables> {}

export default class OpenPollQuery extends PureComponent<Props> {
  render() {
    return <QueryComponent {...this.props} QueryComponent={TypedQuery} query={query} />
  }
}
